export default "__VITE_ASSET__CTwL_08Y__"